import React, { memo, useMemo } from "react";
import { PageContainer, GridBox, Box, Font, useMatchMedia, useSsr } from "@pochta/ui";
import isIOS from "../../../../helpers/isIOS";
import isMobileDevice from "../../../../helpers/isMobileDevice";
import FooterMenu from "./components/FooterMenu";
import FooterSocials from "./components/FooterSocials";
import FooterList from "./components/FooterList";
import { FooterAppStore, FooterGooglePlay, FooterMain, FooterCompactPart, FooterFullPart, FooterBottom, FooterCustomers, FooterBusiness, FooterApps } from "./Footer.styles";
var currentYear = new Date().getFullYear();

var Footer = function Footer(_ref) {
  var options = _ref.options,
      pageContainerMaxWidth = _ref.pageContainerMaxWidth,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? null : _ref$compact,
      _ref$appStore = _ref.appStore,
      appStore = _ref$appStore === void 0 ? null : _ref$appStore,
      _ref$googlePlay = _ref.googlePlay,
      googlePlay = _ref$googlePlay === void 0 ? null : _ref$googlePlay,
      menu = _ref.menu,
      copyrightMenu = _ref.copyrightMenu,
      socials = _ref.socials;
  var desktop = useMatchMedia("desktop");
  var mobile = useMatchMedia("mobile");
  var tablet = useMatchMedia("tablet");

  var _useSsr = useSsr(),
      isSsr = _useSsr.isSsr;

  var isMobSafari = useMemo(function () {
    return isSsr ? false : isIOS() && isMobileDevice();
  }, [isSsr]);
  return /*#__PURE__*/React.createElement(FooterMain, null, /*#__PURE__*/React.createElement(PageContainer, {
    limitMaxWidthBreakpoint: pageContainerMaxWidth
  }, !compact && /*#__PURE__*/React.createElement(FooterFullPart, null, /*#__PURE__*/React.createElement(GridBox, {
    row: true
  }, /*#__PURE__*/React.createElement(FooterCustomers, {
    xs: 12,
    sm: 6,
    xl: 6
  }, /*#__PURE__*/React.createElement(FooterList, {
    list: options === null || options === void 0 ? void 0 : options.leftHalf
  })), /*#__PURE__*/React.createElement(FooterBusiness, {
    xs: 12,
    sm: 6,
    xl: 6
  }, /*#__PURE__*/React.createElement(FooterList, {
    list: options === null || options === void 0 ? void 0 : options.rightHalf
  })))), /*#__PURE__*/React.createElement(FooterCompactPart, null, /*#__PURE__*/React.createElement(GridBox, {
    row: true
  }, /*#__PURE__*/React.createElement(GridBox, {
    xs: 12,
    sm: 8,
    xl: 9
  }, /*#__PURE__*/React.createElement(GridBox, {
    row: true,
    gap: [18]
  }, /*#__PURE__*/React.createElement(GridBox, {
    xs: 12,
    md: 12,
    lg: 8,
    xl: 5
  }, /*#__PURE__*/React.createElement(GridBox, {
    row: true,
    gap: [15, 20]
  }, /*#__PURE__*/React.createElement(FooterMenu, {
    list: menu
  }))), /*#__PURE__*/React.createElement(GridBox, {
    xs: 12,
    md: 12,
    lg: 4,
    xl: 7
  }, /*#__PURE__*/React.createElement(FooterSocials, {
    list: socials
  })))), /*#__PURE__*/React.createElement(FooterApps, {
    xs: 12,
    sm: 4,
    xl: 3,
    flexbox: true,
    justifyContent: {
      xs: "flex-start",
      sm: "flex-end",
      xl: "flex-end"
    }
  }, mobile && isMobSafari && /*#__PURE__*/React.createElement(FooterAppStore, {
    href: appStore
  }), mobile && !isMobSafari && /*#__PURE__*/React.createElement(FooterGooglePlay, {
    href: googlePlay
  }), tablet && /*#__PURE__*/React.createElement(FooterAppStore, {
    href: appStore
  }), desktop && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FooterAppStore, {
    href: appStore
  }), /*#__PURE__*/React.createElement(FooterGooglePlay, {
    href: googlePlay
  })))), /*#__PURE__*/React.createElement(FooterBottom, null, /*#__PURE__*/React.createElement(GridBox, {
    row: true,
    gap: [10, 24]
  }, /*#__PURE__*/React.createElement(FooterMenu, {
    list: copyrightMenu
  }), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Font, {
    size: "s"
  }, currentYear, " \xA9 \u0410\u041E \u041F\u043E\u0447\u0442\u0430 \u0420\u043E\u0441\u0441\u0438\u0438")))))));
};

export default /*#__PURE__*/memo(Footer);